module.exports = __webpack_public_path__ + "img/17.01a44ccd.png";